import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import dayjs from 'dayjs'
import 'leaflet/dist/leaflet.css'
// import * as Sentry from "@sentry/vue";

// import VueToastr from '@deveodk/vue-toastr'
// import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import VueToastr from 'vue-toastr'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import VueApexCharts from 'vue-apexcharts'

import '@/plugins/validationRules'
import '@/plugins/dateService'
import '@/plugins/httpService'

Vue.config.productionTip = false

// Toastr
/* Vue.use(VueToastr, {
  defaultPosition: 'toast-bottom-right',
  defaultType: 'info',
  defaultTimeout: 5000
}) */
Vue.use(VueToastr, {
  defaultTimeout: 5000,
  defaultProgressBar: false,
  defaultProgressBarValue: 0,
  defaultType: 'info',
  defaultPosition: 'toast-bottom-right',
  defaultCloseOnHover: true,
  // defaultStyle: { 'background-color': 'red' },
  defaultStyle: { 'font-family': 'Helvetica' },
  defaultClassNames: ['animated', 'zoomInUp']
})

// SweetAlert dialogs
const swalOptions = {
  reverseButtons: true,
  confirmButtonColor: '#00496f',
  cancelButtonColor: '#cccccc',
  confirmButtonText: 'Aceptar',
  cancelButtonText: 'Cancelar'
}
Vue.use(VueSweetalert2, swalOptions)

// ApexCharts
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// Date filter
Vue.filter('formatDate', function (date) {
  if (date) {
    return dayjs(date).format('DD/MM/YYYY HH:mm')
  } else {
    return ''
  }
})

Vue.prototype.$eventHub = new Vue()
/*
Sentry.init({
	  Vue,
	  dsn: "https://734ac7986f54f53c95e1cf19009b944b@o4506038325149696.ingest.us.sentry.io/4508931780050944",
	  integrations: [
		      Sentry.browserTracingIntegration({ router }),
		      Sentry.replayIntegration(),
		    ],
	   // Tracing
	   tracesSampleRate: 1.0, //  Capture 100% of the transactions
	   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
	   // Session Replay
	   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
           replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur
}); */
	
var vueInstance = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
})
vueInstance.$mount('#app')

export default vueInstance
